import { h } from 'preact';

import actions from '../../store/actions';
import { connect } from 'redux-zero/preact';

import { $lang } from '../../plugins/helper';

const mapToProps = ({
    type, organization, taken_test
}) => ({ type, organization, taken_test });


const PTMessage = (props) => {
    // temporary until all languages are ready
    const instruction_4_1 = $lang('pt.instruction_4_1') || $lang('pt.instruction_4', { attempt: props.organization.attempt_of_test || '3' })
    const attempt_of_test = props.organization.attempt_of_test
    if (props.taken_test) {
        return (
            <div className="instruction-popup">
                {$lang('error.email_submitted') || 'There is already a neoAssessment test result associated with this email.'}
            </div>
        )
    }
    return (
        < ul className="instruction-popup" >
            <li>
                {$lang('test_time', { minutes: 20 })}
            </li>
            <li>
                {$lang('pt.instruction_2')}
            </li>
            <li>
                {$lang('pt.instruction_3')}
            </li>
            <li>
                {
                    attempt_of_test == 1 ? instruction_4_1 : $lang('pt.instruction_4', { attempt: attempt_of_test || '3' })
                }
            </li>
        </ul >
    )
}

const ETMessage = ({ organization }) => (
    <ul className="instruction-popup">
        <li>
            {$lang('test_time', { minutes: organization.duration_test || 20 })}
        </li>
        <li>
            {$lang('total_questions', { total: organization.total_questions || 25 })}
        </li>
        <li>
            {$lang('et.instruction_3')}
        </li>
        <li>
            {$lang('et.instruction_4')}
        </li>
    </ul>
)

const FormMessage = ({ type, organization, startQuestion, handlePrepare, taken_test }) => (
    <div className="et-modal" style="background: #263175c9;">
        <div className="et-modal-body md:et-max-w-md">
            <div className="modal-content et-pb-4 et-pt-10 et-text-left et-px-10">
                <div className="et-pb-3">
                    <p className="et-text-2xl et-text-center et-font-bold">
                        {(taken_test) ? $lang('result_title') || 'Important!' : $lang('ready_to_test')}
                    </p>

                    {type == 'pt' ? <PTMessage organization={organization} taken_test={taken_test} /> : <ETMessage organization={organization} />}

                    <div className="et-flex et-mt-10">
                        <button onClick={startQuestion} className="neo-btn neo-btn--primary et-rounded-full et-px-11 et-py-3 et-mr-auto et-font-light et-capitalize et-shadow-lg">{(taken_test) ? $lang('button.result') || 'Show Result' : $lang('button.start')}</button>
                        <button onClick={() => handlePrepare(false)} className="neo-btn et-rounded-full et-px-11 et-py-3 et-mr-2 et-font-light et-capitalize et-border-gray-300 et-shadow-lg">{$lang('button.cancel')}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
);

export default connect(mapToProps, actions)(FormMessage)